export const CUSTOMIZE_MODAL_CONSTANTS = {
  ADD_NEW_PRODUCT: 'addNewProduct',
  UPDATE_CART: 'updateCart',
  CUSTOMIZATION_MODAL_DATA: 'CUSTOMIZATION_MODAL_DATA',
};
